/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Close_Track2_ButtonInputs */

const en_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x Track 2`)
};

const fr_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x Piste 2`)
};

const de_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x Spur 2`)
};

const it_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x Traccia 2`)
};

const ru_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x Трек 2`)
};

const es_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x Pista 2`)
};

const zh_cn2_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x 轨道 2`)
};

const ja_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x トラック2`)
};

const hi_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x ट्रैक 2`)
};

const pt_pt2_timeline_legacy_close_track2_button = /** @type {(inputs: Timeline_Legacy_Close_Track2_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x Faixa 2`)
};

/**
* | output |
* | --- |
* | "x Track 2" |
*
* @param {Timeline_Legacy_Close_Track2_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_close_track2_button = /** @type {((inputs?: Timeline_Legacy_Close_Track2_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Close_Track2_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_legacy_close_track2_button(inputs)
	if (locale === "de") return de_timeline_legacy_close_track2_button(inputs)
	if (locale === "it") return it_timeline_legacy_close_track2_button(inputs)
	if (locale === "ru") return ru_timeline_legacy_close_track2_button(inputs)
	if (locale === "es") return es_timeline_legacy_close_track2_button(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_legacy_close_track2_button(inputs)
	if (locale === "ja") return ja_timeline_legacy_close_track2_button(inputs)
	if (locale === "hi") return hi_timeline_legacy_close_track2_button(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_legacy_close_track2_button(inputs)
	return en_timeline_legacy_close_track2_button(inputs)
});